// extracted by mini-css-extract-plugin
export var deliveryRow = "_no-a";
export var fixedHeight = "_no-4";
export var freightLogo = "_no-9";
export var fullWidth = "_no-3";
export var priceColumn = "_no-5";
export var radioSelected = "_no-7";
export var radioUnselected = "_no-6";
export var selectedOption = "_no-2";
export var selectedOptionContainer = "_no-1";
export var selection = "_no-0";
export var tallSkeletonText = "_no-8";